module.exports = __webpack_public_path__ + "static/media/r8.414a7341.png";